module.exports = __webpack_public_path__ + "static/media/img_19.35bc464e.png";